<div class="desktop-main-wrapper">
  <router-outlet></router-outlet>
</div>

